<template>
  <div>
    <el-container class="p-3">
      <div>
        <el-form inline>
          <el-form-item label="經銷商">
            <selectCompany :id.sync="condition.company_id" @onSelect="onSelectCompany" />
          </el-form-item>
          <el-form-item label="">
            <selectClient :client-id.sync="condition.client_id" :company-id="condition.company_id" @onSelect="onSelectClient" />
          </el-form-item>
          <el-form-item label="">
            <selectUser :user-id.sync="condition.user_id" @onSelect="onSelectUser" />
          </el-form-item>
        </el-form>
      </div>
    </el-container>

    <div class="">
      <l-map ref="myMap" :center="{ lat: 24.72573174017737, lng: 121.44913845558791 }" :zoom="10" style="height: 85vh; position: absolute; bottom: 0">
        <l-tile-layer :url="osmURL" />
        <v-marker-cluster :options="{ spiderLegPolylineOptions, maxClusterRadius: 80 }">
          <l-marker v-for="(m, index) in mvmsFilter" :key="index" :lat-lng="[m.locate.lat, m.locate.lng]">
            <l-icon :icon-size="[48, 48]" :icon-url="m.Status | iconFilter">
              <div class="headline text-center">
                {{ m.AssetNo }}
              </div>
              <img :src="m.Status | iconFilter" />
            </l-icon>
            <l-popup>
              <div class="p-2 info-window">
                <h3 class="m-0">資產代號: {{ m.AssetNo }}</h3>
                <h4 class="m-0">客戶: {{ m.client.name }}</h4>
                <h4 class="m-0">地址: {{ m.locate.name }}</h4>
                <h4>
                  目前狀態:
                  <el-tag effect="dark" :type="m.Status | statusColorFilter">
                    <strong>
                      {{ m.Status | statusFilter }}
                    </strong>
                  </el-tag>
                </h4>
              </div>
            </l-popup>
          </l-marker>
        </v-marker-cluster>
      </l-map>
    </div>
  </div>
</template>
<script>
import { getMvms, getMvmSelect } from '@/api/mvms';

import { LMap, LTileLayer, LMarker, LIcon, LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

import selectCompany from '@/components/select/companies';
import selectClient from '@/components/select/client.vue';
import selectUser from '@/components/select/user.vue';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';

const methods = {
  async onSelectCompany() {
    this.mvms = await getMvmSelect(this.condition);
    // console.log(this.mvms);
    this.window_open = false;
  },
  async onSelectClient(id) {
    this.mvms = await getMvmSelect(this.condition);
    this.window_open = false;
  },
  async onSelectUser(id) {
    this.mvms = await getMvmSelect(this.condition);
    this.window_open = false;
  },

  async init() {},
};
export default {
  components: {
    selectCompany,
    selectClient,
    selectUser,
    'v-marker-cluster': Vue2LeafletMarkerCluster,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
  },
  filters: {
    iconFilter(key) {
      const icon = {
        success: require('@/icons/mvms/map-icon-success@2x.png'),
        danger: require('@/icons/mvms/map-icon-danger@2x.png'),
        low: require('@/icons/mvms/map-icon-low@2x.png'),
      };
      const map = {
        2: icon.danger,
        4: icon.low,
      };
      return map[key] ? map[key] : icon.success;
    },
    statusFilter(key) {
      const map = {
        2: '連線中',
        4: '未註冊',
      };
      return map[key] ? map[key] : '正常';
    },
    statusColorFilter(key) {
      const map = {
        2: 'danger',
        4: 'warning',
      };
      return map[key] ? map[key] : 'success';
    },
  },
  data() {
    return {
      mvms: [],
      center: { lat: 22.94413357790179, lng: 122.30441566127698 },
      condition: {
        company_id: -10000,
        client_id: -10000,
        user_id: null,
      },
      clusterImagePath: require('@/icons/mvms/map-icon-success@2x.png'),
      osmURL: 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
      mapAttr: {},

      spiderLegPolylineOptions: { weight: 5, color: '#222', opacity: 1 },
    };
  },
  computed: {
    mvmsFilter() {
      return this.mvms.filter((mvm) => {
        return mvm.locate.lat && mvm.locate.lng;
      });
    },
  },
  created() {
    this.init();
    this.$nextTick(() => {});
  },
  methods,
};
</script>
<style>
@import '~leaflet.markercluster/dist/MarkerCluster.css';
@import '~leaflet.markercluster/dist/MarkerCluster.Default.css';

.info-window {
  border: 2px solid black;
  border-radius: 0.5rem;
}

.map {
  height: 800px;
}

.marker-cluster div {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  font-size: 2rem;
  padding: 0.6rem;
  background-color: #00a318cf;
  color: aliceblue;
  border: solid 1px rgba(255, 255, 255, 0.697);
  box-shadow: 0px 0px 10px black;
}

.headline {
  color: #deffe4;
  font-size: 0.5rem;
  font-weight: 500;
  text-shadow: 0 0 10px black;
  border: solid 1px black;
  background-color: #00a318cf;
  border-radius: 10px;
  padding: 1px;
}
</style>
